<template>
    <section class="categories">
        <div class="container container-tight accordion" id="">
                <div class="row categories-row">
                    <div class="col-lg-4 col-md-4 cat">

                        <a class="category-block collapser" @click="showResults" :class="{active: activeCategory == 'account'}" data-category="account" id="account">
                            <div class="category-icon " data-category="account">
                                <img src="@/assets/images/account.svg" data-category="account" alt="account">
                            </div>
                            <div class="category-title" data-category="account">
                                <h4 data-category="account">{{ $t('account') }}</h4>
                            </div>
                        </a>

                    </div>
                    <div class="col-lg-4 col-md-4 cat" >

                        <a class="category-block collapser" @click="showResults" :class="{active: activeCategory == 'payment'}" data-category="payment" id="payment">
                            <div class="category-icon" data-category="payment">
                                <img src="@/assets/images/payments-subscriptions.svg" data-category="payment" alt="payments-subscriptions">
                            </div>
                            <div class="category-title" data-category="payment">
                                <h4 data-category="payment">{{ $t('payment_and_subscription') }}</h4>
                            </div>
                        </a>

                    </div>
                    <div class="col-lg-4 col-md-4 cat">

                        <a class="category-block collapser" @click="showResults" :class="{active: activeCategory == 'content'}" data-category="content" id="content">
                            <div class="category-icon" data-category="content">
                                <img src="@/assets/images/content.svg" data-category="content" alt="content">
                            </div>
                            <div class="category-title" data-category="content">
                                <h4 data-category="content">{{ $t('content') }}</h4>
                            </div>
                        </a>

                    </div>
                </div>
        </div>
    </section>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

export default {
    data: () => {
        return {
            
        }
    },
    computed: {
        activeCategory () {
            return this.$store.getters.activeCategory;
        }
    },
    methods: {
        showResults ()  {
            let windowWidth = window.innerWidth;
            let category = event.target.getAttribute('data-category');
            let categoryBlocks = document.getElementsByClassName('category-block');
            let i;
            for(i=0;i<categoryBlocks.length;i++){
                categoryBlocks[i].classList.remove("active");
            }
            if(this.activeCategory == category) {
                let elements = document.getElementsByClassName('collapse ');
                let elementsArrows = document.getElementsByClassName('categories-content-expand');
                let i;
                for(i=0;i<elements.length;i++){
                    elements[i].classList.remove("show");
                }
                let k;
                for(k=0;k<elements.length;k++){
                    elementsArrows[k].setAttribute("aria-expanded", false);
                }
                
            }
            this.$store.dispatch('showResults', category)
            .then(() => {
                var offset = {
                    offset: -40,
                }
                if(windowWidth < 550){
                    VueScrollTo.scrollTo("#testAC",offset)
                }else {
                    VueScrollTo.scrollTo(".categories")
                }
                
            })
            
            if(this.$route.hash){
                this.$router.push({
                    params: { lang: this.$route.params.lang},
                    hash: ""
                })
            }

            let activeCategoryDiv = document.getElementById(category);
            activeCategoryDiv.classList.add("active");
        }, 
    }
}
</script>
<style scoped>
    .category-block {
        cursor: pointer;
    }
    .category-title h4 {
        font-weight: bold;
    }
    .categories {
        padding: 4vh 0 0 0;
        margin-bottom: 0;
    }
    .categories-row {
        margin: 0 0 40px;
    }
    .category-block.active, .category-block:hover {
        background-color: #f5f5f5;
    }
</style>